(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[327],{

/***/ 8175:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects",
      function () {
        return __webpack_require__(7516);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ Main; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.0_biqbaboplfbrettd7655fr4n2y/node_modules/next/link.js
var next_link = __webpack_require__(4588);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.0_biqbaboplfbrettd7655fr4n2y/node_modules/next/router.js
var next_router = __webpack_require__(8295);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(959);
;// CONCATENATED MODULE: ./src/components/header.tsx




var Header = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), menuIsOpen = ref[0], setMenusIsOpen = ref[1];
    (0,react.useEffect)(function() {
        router.events.on("routeChangeComplete", function() {
            return setMenusIsOpen(false);
        });
        router.events.on("routeChangeError", function() {
            return setMenusIsOpen(false);
        });
        return function() {
            router.events.off("routeChangeComplete", function() {
                return setMenusIsOpen(false);
            });
            router.events.off("routeChangeError", function() {
                return setMenusIsOpen(false);
            });
        };
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: "flex justify-between items-center py-5 border-b-2 md:items-baseline border-b-slate-200 px-3 md:px-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "p-0 m-0 text-4xl font-extrabold text-transparent lowercase bg-clip-text bg-gradient-to-r from-rose-400 via-indigo-500 to-purple-600 md:inline",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: "chris bailey"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "flex relative z-50 items-center mr-2 space-x-2 w-6 h-6 lg:hidden focus:outline-none",
                onClick: function() {
                    return setMenusIsOpen(!menuIsOpen);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex relative justify-center items-center w-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "absolute w-full h-[2px] bg-current transition transform ".concat(menuIsOpen ? "translate-y-0 rotate-45" : "-translate-y-2")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "absolute w-full h-[2px] bg-current transition transform ".concat(menuIsOpen ? "opacity-0 translate-x-3" : "opacity-100")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "absolute w-full h-[2px] bg-current transition transform ".concat(menuIsOpen ? "translate-y-0 -rotate-45" : "translate-y-2")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: "".concat(menuIsOpen ? "grid" : "invisible", " absolute top-0 left-0 z-40 md:visible md:block place-items-center w-screen h-screen bg-white md:relative md:top-auto md:left-auto md:w-auto md:h-auto md:bg-transparent"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "flex flex-col gap-3 justify-center md:flex-row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "text-2xl md:text-lg link__gradient",
                                    children: "home"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/writing",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "text-2xl md:text-lg link__gradient",
                                    children: "writing"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/projects",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "text-2xl md:text-lg link__gradient",
                                    children: "projects"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/about",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "text-2xl md:text-lg link__gradient",
                                    children: "about"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/layouts/main.tsx


var Main = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col mx-auto max-w-[65ch]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    className: "px-3 md:px-0 mt-8",
                    children: children
                })
            ]
        })
    });
};


/***/ }),

/***/ 7608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ SanityImage; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(9447);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-sanity-image@4.1.0_6o37wieygg7wc6c34vtxpmykcq/node_modules/next-sanity-image/dist/index.js
var dist = __webpack_require__(8487);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.0_biqbaboplfbrettd7655fr4n2y/node_modules/next/image.js
var next_image = __webpack_require__(1414);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/.pnpm/@sanity+client@3.4.1/node_modules/@sanity/client/lib/sanityClient.js
var sanityClient = __webpack_require__(7153);
var sanityClient_default = /*#__PURE__*/__webpack_require__.n(sanityClient);
;// CONCATENATED MODULE: ./src/lib/sanityClient.ts

/* harmony default export */ var lib_sanityClient = (sanityClient_default()({
    projectId: "djmgfrsn",
    dataset: "production" || 0,
    useCdn: true,
    apiVersion: "2021-08-31"
}));

;// CONCATENATED MODULE: ./src/lib/sanityImage.tsx






var SanityImage = function(param) {
    var source = param.source;
    var imageProps = (0,dist/* useNextSanityImage */.J)(lib_sanityClient, source);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageProps), {
        layout: "responsive",
        sizes: "(max-width: 65ch)"
    }));
};


/***/ }),

/***/ 7516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ projects; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./src/lib/sanityImage.tsx + 1 modules
var sanityImage = __webpack_require__(7608);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.0_biqbaboplfbrettd7655fr4n2y/node_modules/next/link.js
var next_link = __webpack_require__(4588);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(959);
;// CONCATENATED MODULE: ./src/components/IconLink.tsx



var IconLink = function(param) {
    var url = param.url, type = param.type;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: url,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "p-1 bg-transparent rounded transition-colors duration-300 ease-in-out hover:bg-purple-300",
            children: getIcon(type)
        })
    });
};
function getIcon(type) {
    switch(type){
        case "github":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                strokeWidth: 1.5,
                stroke: "currentColor",
                className: "w-4 h-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5"
                })
            });
        case "web":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                strokeWidth: 1.5,
                stroke: "currentColor",
                className: "w-4 h-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"
                })
            });
        default:
            return null;
    }
}

;// CONCATENATED MODULE: ./src/components/ProjectCard.tsx



var ProjectCard = function(param) {
    var project = param.project;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: "flex flex-col border-b-2 border-gray-200",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: project.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                className: "overflow-hidden m-0 rounded h-[150px] grow md:grow-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sanityImage/* SanityImage */.d, {
                    source: project.mainImage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-0 grow",
                children: project.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-4 justify-end mb-2",
                children: [
                    project.liveLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLink, {
                        url: project.liveLink,
                        type: "web"
                    }),
                    project.githubLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLink, {
                        url: project.githubLink,
                        type: "github"
                    })
                ]
            })
        ]
    }, project._id);
};
/* harmony default export */ var components_ProjectCard = (ProjectCard);

// EXTERNAL MODULE: ./src/layouts/main.tsx + 1 modules
var main = __webpack_require__(9802);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.0_biqbaboplfbrettd7655fr4n2y/node_modules/next/head.js
var head = __webpack_require__(4256);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/pages/projects.tsx




var Projects = function(param) {
    var projects = param.projects;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "chrisbailey.dev - projects"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "list of projects have either worked on or created"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(main/* Main */.o, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-3xl font-extrabold text-indigo-500 lowercase",
                        children: "projects"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid grid-cols-1 gap-4 md:grid-cols-2 prose",
                        children: projects.map(function(project) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProjectCard, {
                                project: project
                            }, project._id);
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var projects = (Projects);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [572,365,774,888,179], function() { return __webpack_exec__(8175); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);